'use client'

import type { HTMLProps } from 'react'
import Image from 'next/image'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import { useAppearance, variantsDefault } from '@/shared/utils'
import { EventHeader } from '@/shared/ui/event-header'
import { IEventPreview } from '@/interfaces/events'
import { MotionLink } from '@/shared/ui/link'
import style from './pinned-event.module.scss'

interface PinnedEventProps
  extends Omit<HTMLProps<HTMLDivElement>, 'id' | 'title'>,
    Omit<IEventPreview, 'blocks' | 'stages'> {}

export const PinnedEvent = (props: PinnedEventProps) => {
  const { className, date_end, date_start, location, category, title, image_preview, slug } = props
  const { ref: articleRef, animate: articleAnimate } = useAppearance()

  return (
    <MotionLink
      className={clsx(className, style.container)}
      ref={articleRef}
      href={`/events/${slug}`}
      initial="hidden"
      animate={articleAnimate}
      variants={variantsDefault}
    >
      <EventHeader className={style.header} category={category} date={date_start ?? date_end} location={location} />
      <Image
        className={style.image}
        src={image_preview?.url ? image_preview.url : '/img-placeholder.svg'}
        alt="main-event"
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
      />
      <Text className={style.footer} type="t1" tagName="p">
        {title}
      </Text>

      <svg
        className={style.pinIcon}
        fill="none"
        viewBox="0 0 25 25"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M21.21 10.25a.71.71 0 0 0 0-1l-5.38-5.38a.71.71 0 0 0-1 0l-5.1 5.1s-2.45-1.24-5.08.89a.71.71 0 0 0-.06 1.05l9.57 9.58a.7.7 0 0 0 1.07-.08c.74-.99 1.91-3.02.9-5.05l5.08-5.1Z" />
        <path d="M9.37 15.7 5.1 19.99" />
      </svg>
    </MotionLink>
  )
}
